module.exports = __webpack_public_path__ + "static/media/avg_pace.a7c0dd3a.svg";